// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as PromotionActions} from '../duck';
import Promotions from '../components/Promotions';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    error: state.promotions.error,
    currency: state.currency.currency,
    updatePromotionSuccess: state.promotions.updatePromotionSuccess,
    selectedState: state.promotions.selectedState,
    promotions: state.promotions.promotions,
    isFetchingPromotions: state.promotions.isFetchingPromotions,
    isSaving: state.promotions.isSaving,
    store: state.store.store,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...PromotionActions}, dispatch)
)(Promotions);
